import type { ReportGroup } from '../types';
import { operations } from './operations';
import { overview } from './overview';
import { products } from './products';
import { rate } from './rate';
import { reasons } from './reasons';

export const warranties = {
  key: 'warranties',
  label: 'Warranties',
  isEnabled: ({ isWarrantyEnabled }) => isWarrantyEnabled,
  filters: { claimItems: { claimTypes: ['Warranty'] } },
  reports: [overview, rate, products, reasons, operations],
} as const satisfies ReportGroup;
